window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
theme.Announcement = (function() {

  function Announcement(container) {

    this.$bannerSlider = $(container).find('.banner__slider');

    var bannerSliderSettings = {
      autoplay: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: window.theme.settings.grid_small || 768,
          settings: {
            arrows: false
          }
        }
      ]
    };

    this.$bannerSlider.slick(bannerSliderSettings);
  }

  return Announcement;
})();
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  // var selectors = {
  //   addToCart: '[data-add-to-cart]',
  //   addToCartText: '[data-add-to-cart-text]',
  //   comparePrice: '[data-compare-price]',
  //   comparePriceText: '[data-compare-text]',
  //   originalSelectorId: '[data-product-select]',
  //   priceWrapper: '[data-price-wrapper]',
  //   productFeaturedImage: '[data-product-featured-image]',
  //   productJson: '[data-product-json]',
  //   productPrice: '[data-product-price]',
  //   productThumbs: '[data-product-single-thumbnail]',
  //   singleOptionSelector: '[data-single-option-selector]'
  // };

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '.product__thumbnail',
    singleOptionSelector: '[data-single-option-selector]'
  };

  var afteraySvg = document.querySelector('.icon-afterpay-logo');
  var zippaySvg = document.querySelector('.icon-zippay-logo');
  if (afteraySvg) {
    $(afteraySvg).addClass("icon--full-color");
  }
  if (zippaySvg) {
    $(zippaySvg).addClass("icon--full-color");
  }

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

		// Listen to the form submit event
		var forms = document.querySelectorAll('.product__form');
    if(forms) {
      var self = this;
      $.each(forms, function(i, form) {
        form.addEventListener('submit', self.addProductHandler.bind(self));
      })
    }

    this.$thumbs = $(selectors.productThumbs);
    if (this.$thumbs.length) {
      $('.product__thumbnails').slick({
        slidesToShow: 1,
        arrows: true,
        dots: false,
        infinite: false
      });
    }

    // Handle image changing
    this.$thumbs.on('click'+ this.namespace, function(e) {
      e.preventDefault();
      $('[data-product-featured-image]').attr('src', e.currentTarget.href);
    });

    var tabs = document.querySelectorAll('.tabs li');
    var tabsContent = document.querySelectorAll('.tabs-content li');

    $.each(tabs, function(i, tab) {
      tab.addEventListener('click', function() {
        event.preventDefault();
        $.each(tabs, function(i, tab1) {
          tab1.classList.remove('active');
        });

        this.classList.add('active');
        var link = $(this).find('a');
        var id;
        if(link) {
          id = link.attr("href").split('#')[1];
        }
        $.each(tabsContent, function(i, tabContent) {
          tabContent.classList.add('hide-content');
        });
        setTimeout(function() {
          $.each(tabsContent, function(i, tabContent1) {
            tabContent1.classList.remove('active');
          });
        }, 300);
        var selectedTab = document.querySelector('#' + id);
        setTimeout(function() {
          if(selectedTab) {
            selectedTab.classList.add('active');
          }
        }, 300);
        setTimeout(function() {
          if(selectedTab) {
            selectedTab.classList.remove('hide-content');
          }
        }, 350);
      });
    });


    // Handle quantities plus and minus buttons
    var plusBtns = document.querySelectorAll('.qty-plus');
    if(plusBtns) {
      plusBtns.forEach(function(plusBtn) {
        plusBtn.addEventListener('click', function(event) {
          event.preventDefault();
          var inputQty = plusBtn.parentElement.querySelector('.qty-input');
          if(inputQty) {
            var qty = parseInt(inputQty.getAttribute('value'));
            qty++;
            inputQty.setAttribute('value', qty);
          }
        });
      });
    }
    var minusBtns = document.querySelectorAll('.qty-minus');
    if(minusBtns) {
      minusBtns.forEach(function(minusBtn) {
        minusBtn.addEventListener('click', function(event) {
        event.preventDefault();
          var inputQty = minusBtn.parentElement.querySelector('.qty-input');
          if(inputQty) {
            var qty = parseInt(inputQty.getAttribute('value'));
            if (qty > 1) {
              qty--;
              inputQty.setAttribute('value', qty);
            }
          }
        });
      });
    }

    //Initialise upsell slider
    $('.upsell--slider__product-page').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false
    });

    var upsellAddBtns = document.querySelectorAll('.upsell__product--add-product');
    if(upsellAddBtns) {
      $.each(upsellAddBtns, function(i, btn) {
        btn.addEventListener('click', function() {
          var self = this;
          var upsellProdVariantID = this.getAttribute('data-variant');
          upsellProdEvent(btn);
          self.classList.add('btn--loading');
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { id: upsellProdVariantID, quantity: 1 },
            dataType: 'JSON',
            success: function(response) {
              theme.cart.fetchData(function() {
                 theme.cart.openCartDrawer();
                 theme.cart.updateBadges();
                 theme.cart.updateSubtotal();
                 theme.cart.updateCartItems(function() {
                   // Stop showing as loading
                   self.classList.remove('btn--loading');
                 });
              });
            },
            error: function(err) {
              console.log('Product was not added to the cart: ', err);
            }

          })
        });
      });
    }

    productViewEvent(this.$container[0]);

    customSelect('.custom-select');
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var $variantThumb = $('[data-variant-id="' + variant.id + '"]');
      var index = $variantThumb.data('slick-index');
      $('.product__thumbnails').slick('slickGoTo', index);
    },

    /**
     * Handler to add product to cart via ajax request
     */
     addProductHandler: function(e) {

       e.preventDefault();

       // Get the basic form data
       var form = e.target;
       var data = {
         id: form.id.value,
         quantity: form.quantity.value
       };

       // Show as loading
       var button = form.add;
       button.classList.add('btn--loading');
       var hasOffer = button.getAttribute('data-has-offer');

       // Look for form items with a name starting with "properties"
       var properties = {};
       var propertyInputs = document.querySelectorAll('[name*="properties"]');
       var length = propertyInputs.length;

       // Push all the found properties into an object
       for (var i = 0; i < length; i++) {
         if (propertyInputs[i].value) {
           var propertyName = propertyInputs[i].name;
           propertyName = propertyName.substring(11, propertyName.length - 1);
           properties[propertyName] = propertyInputs[i].value;
         }
       }

       if (hasOffer) {
        properties['_offer'] = 'Offer';
       }

       // If there were properties, attach them to the data to send
       if (Object.keys(properties).length) {
         data.properties = properties;
       }
       // Send the updated cart data
       $.ajax({
         method: 'POST',
         url: '/cart/add.js',
         data: data,
         dataType: 'JSON',
         success: function() {
           theme.cart.fetchData(function() {
             theme.cart.openCartDrawer();
             theme.cart.updateBadges();
             theme.cart.updateSubtotal();
             theme.cart.updateCartItems(function() {
               // Stop showing as loading
               button.classList.remove('btn--loading');
             });
             if (hasOffer) {
              theme.cart.addFreeProduct();
             }
           });
         }
       });
     },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });


  /*var windowWidth;
  function videoPosition() {
    windowWidth = $(window).width();

    if(windowWidth <= 990) {
      $('.product-video').appendTo('.video-container-mobile');

    } else {
      $('.product-video').appendTo('.video-container-desktop');
    }
  }

  function upsellPosition() {
    windowWidth = $(window).width();

    if(windowWidth <= 990) {
      $('.upsell-element').appendTo('.upsell-container--mobile');

    } else {
      $('.upsell-element').appendTo('.upsell-container--desktop');
    }

  }

  $(document).ready(function(){
    videoPosition();
    upsellPosition();
  });

  $(window).on("resize", function() {
      windowWidth = $(window).width();
      videoPosition();
      upsellPosition();
  });*/





  return Product;
})();

theme.HeroSlider = (function() {

  /**
	 * Constructor
	 */
  function HeroSlider(container) {

    this.settings = container.dataset.sectionSettings || "{}";
    this.$slider = $(container).find('.slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed,
      speed: (userSettings.slide_speed / 2),
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);
  }

  /**
	 * Event handler that updates the fade setting based on slidesToShow
	 */
  function slideHandler(e) {

    if (e.target.name.indexOf('slidesToShow')) {
      var fade = window.top.document.querySelector('[id$=fade]');

      if (e.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      }
      else {
        fade.checked = true;
        fade.disabled = false;
      }
    }
  }

  /**
	 * Shopify section methods
	 */
  HeroSlider.prototype = $.extend({}, HeroSlider.prototype, {

    onSelect: function(e) {
      window.top.addEventListener('input', slideHandler);
      window.top.addEventListener('change', slideHandler);
    },

    onDeselect: function(e) {
      window.top.removeEventListener('input', slideHandler);
      window.top.removeEventListener('change', slideHandler);
    },

    onBlockSelect: function(e) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(e.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    },

    onBlockDeselect: function(e) {
      // Resume carousel
      this.$slider.slick('slickPlay');
    }

  });

  return HeroSlider;
})();

theme.Testimonials = (function() {

  /**
	 * Constructor
	 */
  function Testimonials(container) {

    this.settings = container.dataset.sectionSettings || "{}";
    this.$slider = $(container).find('.slider');

    // Parse the settings string passed through from liquid
    var userSettings = JSON.parse(this.settings);

    // Create some defaults
    var defaultSettings = {
      infinite: true,
      autoplaySpeed: userSettings.slide_speed,
      speed: (userSettings.slide_speed / 2),
      responsive: [
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    // Merge the objects - userSettings will have precedence
    var sliderSettings = $.extend(defaultSettings, userSettings);
    // Init slick carousel
    this.$slider.slick(sliderSettings);
  }

  /**
	 * Event handler that updates the fade setting based on slidesToShow
	 */
  function slideHandler(e) {

    if (e.target.name.indexOf('slidesToShow')) {
      var fade = window.top.document.querySelector('[id="fade"]');

      if (e.target.value > 1) {
        fade.checked = false;
        fade.disabled = true;
      }
      else {
        fade.checked = true;
        fade.disabled = false;
      }
    }
  }

  /**
	 * Shopify section methods
	 */
  Testimonials.prototype = $.extend({}, Testimonials.prototype, {

    onSelect: function(e) {
      window.top.addEventListener('input', slideHandler);
      window.top.addEventListener('change', slideHandler);
    },

    onDeselect: function(e) {
      window.top.removeEventListener('input', slideHandler);
      window.top.removeEventListener('change', slideHandler);
    },

    onBlockSelect: function(e) {
      // Go to the currently selected block in slick carousel and pause
      var index = parseInt(e.target.dataset.slickIndex, 10);
      this.$slider.slick('slickGoTo', index).slick('slickPause');
    },

    onBlockDeselect: function(e) {
      // Resume carousel
      this.$slider.slick('slickPlay');
    }

  });

  return Testimonials;
})();

theme.FeaturedOn = (function() {
	function FeaturedOn(container) {
		this.settings = container.dataset.sectionSettings || '{}';
		this.$slider = $(container).find('.featured-on--slick');

		var userSettings = JSON.parse(this.settings);

		var defaultSettings = {
			dots: false,
			infinite: true,
			slidesToShow: 7,
			slidesToScroll: 1,
			focusOnSelect: false,
		    focusOnChange: false,
		    accessibility: false,
			responsive: [
				{
					breakpoint: window.theme.settings.grid_medium || 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1
					}
				}
			]
		}

		var sliderSettings = $.extend(defaultSettings, userSettings);
		this.$slider.slick(sliderSettings);
	}

	return FeaturedOn;

})();
theme.FeaturedCollections = (function() {
	function FeaturedCollections(container) {
		this.settings = container.dataset.sectionSettings || '{}';
		this.$slider = $(container).find('.featured-collections--slider');

		var userSettings = JSON.parse(this.settings);

		var defaultSettings = {
			focusOnSelect: false,
			focusOnChange: false,
			accessibility: false,
			dots: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: false,
			prevArrow: $('.prev'),
			nextArrow: $('.next'),
			responsive: [
				{
					breakpoint: window.theme.settings.grid_large || 992,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: window.theme.settings.grid_medium || 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true
					}
				}
			]
		}

		var sliderSettings = $.extend(defaultSettings, userSettings);
		this.$slider.slick(sliderSettings);
	}

	return FeaturedCollections;
})();
theme.FeaturedProduct = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '.product__thumbnail',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function FeaturedProduct(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

		// Listen to the form submit event
		var form = document.querySelector('.product__form');
		form.addEventListener('submit', this.addProductHandler.bind(this));

    this.$thumbs = $(selectors.productThumbs);
    if (this.$thumbs.length) {
      $('.product__thumbnails').slick({
        slidesToShow: 1,
        arrows: true,
        prevArrow: $('.prod--prev'),
        nextArrow: $('.prod--next')
      });
    }

    // Handle image changing
    this.$thumbs.on('click'+ this.namespace, function(e) {
      // e.preventDefault();
      $('[data-product-featured-image]').attr('src', e.currentTarget.href);
    });

    // Handle quantities plus and minus buttons
    var plusBtn = document.querySelector('.qty-plus');
    if(plusBtn) {
      plusBtn.addEventListener('click', function(event) {
        event.preventDefault();
        var inputQty = document.querySelector('.qty-input');
        if(inputQty) {
          var qty = parseInt(inputQty.getAttribute('value'));
          qty++;
          inputQty.setAttribute('value', qty);
        }
      });
    }
    var minusBtn = document.querySelector('.qty-minus');
    if(minusBtn) {
      minusBtn.addEventListener('click', function(event) {
        event.preventDefault();
        var inputQty = document.querySelector('.qty-input');
        if(inputQty) {
          var qty = parseInt(inputQty.getAttribute('value'));
          if (qty > 1) {
            qty--;
            inputQty.setAttribute('value', qty);
          }
        }
      });
    }

    productViewEvent(this.$container[0]);
  }

  FeaturedProduct.prototype = $.extend({}, FeaturedProduct.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var $variantThumb = $('[data-variant-id="' + variant.id + '"]');
      var index = $variantThumb.data('slick-index');
      $('.product__thumbnails').slick('slickGoTo', index);
    },

    /**
     * Handler to add product to cart via ajax request
     */
     addProductHandler: function(e) {

       e.preventDefault();

       // Get the basic form data
       var form = e.target;
       var data = {
         id: form.id.value,
         quantity: form.quantity.value
       };

       // Show as loading
       var button = form.add;
       button.classList.add('btn--loading');
       var hasOffer = button.getAttribute('data-has-offer');

       // Look for form items with a name starting with "properties"
       var properties = {};
       var propertyInputs = document.querySelectorAll('[name*="properties"]');
       var length = propertyInputs.length;

       // Push all the found properties into an object
       for (var i = 0; i < length; i++) {
         if (propertyInputs[i].value) {
           var propertyName = propertyInputs[i].name;
           propertyName = propertyName.substring(11, propertyName.length - 1);
           properties[propertyName] = propertyInputs[i].value;
         }
       }

       if (hasOffer) {
        properties['_offer'] = 'Offer';
       }

       // If there were properties, attach them to the data to send
       if (Object.keys(properties).length) {
         data.properties = properties;
       }

       // Send the updated cart data
       $.ajax({
         method: 'POST',
         url: form.action,
         data: data,
         dataType: 'JSON',
         success: function() {
           theme.cart.fetchData(function() {
             theme.cart.openCartDrawer();
             theme.cart.updateBadges();
             theme.cart.updateSubtotal();
             theme.cart.updateCartItems(function() {
               // Stop showing as loading
               button.classList.remove('btn--loading');
             });
             if (hasOffer) {
              theme.cart.addFreeProduct();
             }
           });
         }
       });
     },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return FeaturedProduct;
})();

theme.heroPlaylist = (function() {

var slideWrapper = $(".main-slider"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          });
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "mute"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratio) {
  if (!iframes[0]) return;
  var win = $(".main-slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: 0,
         top: 0
        });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: 0
      });
    }
  });
}

// DOM Ready
$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"pause");
    }, 1000);
    // resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
      // slideWrapper.slick("slickPlay");
    }
  });

  //start the slider
  slideWrapper.slick({
    // fade:true,
    autoplay: false,
    lazyLoad:"progressive",
    speed:300,
    arrows:false,
    dots:true,
    cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
  });

  var placeholders = document.querySelectorAll('.video-placeholder');
  var allVideos = document.querySelectorAll('.video-mobile');
  if (placeholders) {
    placeholders.forEach(function(placeholder) {
      placeholder.addEventListener('click', function() {
        placeholders.forEach(function(ph) {
          ph.style.display = 'block';
        });
        allVideos.forEach(function(video) {
          video.style.display = 'none';
        });
        this.style.display = 'none';
        var videoClass = this.getAttribute('data-video');
        var videoEl = document.querySelector('.' + videoClass);
        if (videoEl) {
          videoEl.style.display = 'block';
        }
      });
    });
  }
});

// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  // resizePlayer(iframes, 16/9);
});

// return heroPlaylist;
})();
theme.heroSingleVideo = (function() {

  var videoWrapper = document.getElementById('hero-video');

  if (videoWrapper) {
    var w = window.innerWidth;

    var options = {}

    var checkSize = function(data) {
      if (w < 769) {
        options = {
          id: videoWrapper.dataset.videoId,
          width: 640,
          loop: true,
          autoplay: true,
          background: videoWrapper.dataset.background,
          transparent: false
        };
      } else {
        options = {
          id: videoWrapper.dataset.videoId,
          width: 640,
          loop: true,
          autoplay: true,
          background: videoWrapper.dataset.background,
          transparent: false
        };
      }
    }

    checkSize();
    var heroVideo = new Vimeo.Player('hero-video', options);

    heroVideo.on('loaded', function() {
      videoWrapper.classList.add('is-loaded');
    });
  }

  




// DOM Ready
$(function() {
  
  var placeholders = document.querySelectorAll('.video-placeholder');
  var allVideos = document.querySelectorAll('.video-mobile');
  if (placeholders) {
    placeholders.forEach(function(placeholder) {
      placeholder.addEventListener('click', function() {
        placeholders.forEach(function(ph) {
          ph.style.display = 'block';
        });
        allVideos.forEach(function(video) {
          video.style.display = 'none';
        });
        this.style.display = 'none';
        var videoClass = this.getAttribute('data-video');
        var videoEl = document.querySelector('.' + videoClass);
        if (videoEl) {
          videoEl.style.display = 'block';
        }
      });
    });
  }
});

// return heroSingleVideo;
})();
theme.SocialFeed = (function() {

  function SocialFeed(container) {

    $.fn.randomize = function(selector){
      var $elems = selector ? $(this).find(selector) : $(this).children(),
          $parents = $elems.parent();

      $parents.each(function(){
          $(this).children(selector).sort(function(){
              return Math.round(Math.random()) - 0.5;
          }).detach().appendTo(this);
      });

      return this;
    };

    $('.social-posts').find('.social-posts__slider').randomize('.social-posts__card');



    this.$socialSlider = $(container).find('.social-posts__slider');


    var socialSliderSettings = {
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      centerMode: true,
      focusOnSelect: false,
      focusOnChange: false,
      accessibility: false,
      responsive: [
        {
          breakpoint: window.theme.settings.grid_large || 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: false,
            focusOnChange: false,
            accessibility: false,
          }
        },
        {
          breakpoint: window.theme.settings.grid_medium || 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            arrows: false,
            focusOnSelect: false,
            accessibility: false,
          }
        },
        {
          breakpoint: window.theme.settings.grid_small || 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            arrows: false,
            focusOnSelect: false,
            focusOnChange: false,
            accessibility: false,
          }
        }
      ]
    };

    this.$socialSlider.slick(socialSliderSettings);
// $('.slider').slick('slickGoTo', number);
    // $('.social-posts__slider').slickGoTo(2);
  }

  return SocialFeed;
})();
theme.VideoReviews = (function() {
  function VideoReviews(container) {
    var allVideosOverlay = document.querySelectorAll('.video-reviews--video__overlay');
    
    if(allVideosOverlay) {
      $.each(allVideosOverlay, function(i, videoOverlay) {
        videoOverlay.addEventListener('click', setActive);
      });
    }


    // Listen to the form submit event
    var forms = document.querySelectorAll('.product__form');
    if(forms) {
      var self = this;
      $.each(forms, function(i, form) {
        form.addEventListener('submit', addProductHandler);
      })
    }


    // Handle quantities plus and minus buttons
    var plusBtns = document.querySelectorAll('.qty-plus');
    if(plusBtns) {
      plusBtns.forEach(function(plusBtn) {
        plusBtn.addEventListener('click', function(event) {
          event.preventDefault();
          var inputQty = plusBtn.parentElement.querySelector('.qty-input');
          if(inputQty) {
            var qty = parseInt(inputQty.getAttribute('value'));
            qty++;
            inputQty.setAttribute('value', qty);
          }
        });
      });
    }
    var minusBtns = document.querySelectorAll('.qty-minus');
    if(minusBtns) {
      minusBtns.forEach(function(minusBtn) {
        minusBtn.addEventListener('click', function(event) {
        event.preventDefault();
          var inputQty = minusBtn.parentElement.querySelector('.qty-input');
          if(inputQty) {
            var qty = parseInt(inputQty.getAttribute('value'));
            if (qty > 1) {
              qty--;
              inputQty.setAttribute('value', qty);
            }
          }
        });
      });
    }
  }

  function setActive() {
    var id = this.getAttribute('data-id');
    var videoWrappers = document.querySelectorAll('.video-reviews--video__wrapper');
    if(videoWrappers) {
      $.each(videoWrappers, function(i, wrapper) {
        wrapper.classList.remove('active');
      });
    }

    var videoWrapper = document.querySelector('.video-reviews--video__wrapper-' + id);
    if(videoWrapper) {
      videoWrapper.classList.add('active');
    }
    var video = document.querySelector('.video-reviews--video-' + id + ' iframe');
    if(video) {
      var src = video.src;
      var activeVideo = document.querySelector('.video-reviews--default iframe');
      if(activeVideo) {
        if (src.includes('?')) {
          activeVideo.src = src + '&autoplay=1';
        } else {
          activeVideo.src = src + '?&autoplay=1';
        }
        window.location = '#video-reviews';
      }
    }
  }


  /**
     * Handler to add product to cart via ajax request
     */
  function addProductHandler(e) {

   e.preventDefault();

   // Get the basic form data
   var form = e.target;
   var data = {
     id: form.id.value,
     quantity: form.quantity.value
   };

   // Show as loading
   var button = form.add;
   button.classList.add('btn--loading');

   // Look for form items with a name starting with "properties"
   var properties = {};
   var propertyInputs = document.querySelectorAll('[name*="properties"]');
   var length = propertyInputs.length;

   // Push all the found properties into an object
   for (var i = 0; i < length; i++) {
     if (propertyInputs[i].value) {
       var propertyName = propertyInputs[i].name;
       propertyName = propertyName.substring(11, propertyName.length - 1);
       properties[propertyName] = propertyInputs[i].value;
     }
   }

   // If there were properties, attach them to the data to send
   if (Object.keys(properties).length) {
     data.properties = properties;
   }
   // Send the updated cart data
   $.ajax({
     method: 'POST',
     url: '/cart/add.js',
     data: data,
     dataType: 'JSON',
     success: function() {
       theme.cart.fetchData(function() {
         theme.cart.openCartDrawer();
         theme.cart.updateBadges();
         theme.cart.updateSubtotal();
         theme.cart.updateCartItems(function() {
           // Stop showing as loading
           button.classList.remove('btn--loading');
         });
       });
     }
   });
  }

  return VideoReviews;
})();
theme.Collection = (function() {

  function Collection(container) {
    var selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      comparePrice: '[data-compare-price]',
      comparePriceText: '[data-compare-text]',
      originalSelectorId: '[data-product-select]',
      priceWrapper: '[data-price-wrapper]',
      productFeaturedImage: '[data-product-featured-image]',
      productJson: '[data-product-json]',
      productPrice: '[data-product-price]',
      productThumbs: '.product__thumbnail',
      singleOptionSelector: '[data-single-option-selector]'
    };

    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // Listen to the form submit event
    var self = this;
    var forms = document.querySelectorAll('.product__form');
    $.each(forms, function(i, form) {
      form.addEventListener('submit', self.addProductHandler.bind(self));
    });

    this.$thumbs = $(selectors.productThumbs);
    if (this.$thumbs.length) {
      $('.product__thumbnails').slick({
        slidesToShow: 1,
        prevArrow: $('.prod--prev'),
        nextArrow: $('.prod--next')
      });
    }

    // Handle image changing
    this.$thumbs.on('click'+ this.namespace, function(e) {
      e.preventDefault();
      $('[data-product-featured-image]').attr('src', e.currentTarget.href);
    });

    // Handle quantities plus and minus buttons
    var plusBtns = document.querySelectorAll('.qty-plus');
    if(plusBtns) {
      $.each(plusBtns, function(i, plusBtn) {
        plusBtn.addEventListener('click', function(event) {
          event.preventDefault();
          var prodId = this.getAttribute('data-product-id');
          var inputQty = document.querySelector('.qty-input-' + prodId);
          if(inputQty) {
            var qty = parseInt(inputQty.getAttribute('value'));
            qty++;
            inputQty.setAttribute('value', qty);
          }
        });
      });
    }
    var minusBtns = document.querySelectorAll('.qty-minus');
    if(minusBtns) {
      $.each(minusBtns, function(i, minusBtn) {
        minusBtn.addEventListener('click', function(event) {
          event.preventDefault();
          var prodId = this.getAttribute('data-product-id');
          var inputQty = document.querySelector('.qty-input-' + prodId);
          if(inputQty) {
            var qty = parseInt(inputQty.getAttribute('value'));
            if (qty > 1) {
              qty--;
              inputQty.setAttribute('value', qty);
            }
          }
        });
      });

    }

    var rolloverImages = document.querySelectorAll('.product-card--rollover');
//     if(rolloverImages) {
//       rolloverImages.forEach(function(rolloverImage) {
//         rolloverImage.addEventListener('touchstart', function() {
//           this.classList.add('product-card--touched');
//         });
//       });

//       rolloverImages.forEach(function(rolloverImage) {
//         rolloverImage.addEventListener('touchend', function() {
//           this.classList.remove('product-card--touched');
//         });
//       });
//     }

  }

  Collection.prototype = $.extend({}, Collection.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var $variantThumb = $('[data-variant-id="' + variant.id + '"]');
      var index = $variantThumb.data('slick-index');
      $('.product__thumbnails').slick('slickGoTo', index);
    },

    /**
     * Handler to add product to cart via ajax request
     */
     addProductHandler: function(e) {

       e.preventDefault();

       // Get the basic form data
       var form = e.target;
       var data = {
         id: form.id.value,
         quantity: form.quantity.value
       };

       // Show as loading
       var button = form.add;
       button.classList.add('btn--loading');
       var hasOffer = button.getAttribute('data-has-offer');

       // Look for form items with a name starting with "properties"
       var properties = {};
       var propertyInputs = document.querySelectorAll('[name*="properties"]');
       var length = propertyInputs.length;

       // Push all the found properties into an object
       for (var i = 0; i < length; i++) {
         if (propertyInputs[i].value) {
           var propertyName = propertyInputs[i].name;
           propertyName = propertyName.substring(11, propertyName.length - 1);
           properties[propertyName] = propertyInputs[i].value;
         }
       }

       if (hasOffer) {
        properties['_offer'] = 'Offer';
       }

       // If there were properties, attach them to the data to send
       if (Object.keys(properties).length) {
         data.properties = properties;
       }

       // Send the updated cart data
       $.ajax({
         method: 'POST',
         url: '/cart/add.js',
         data: data,
         dataType: 'json',
         success: function() {
           theme.cart.fetchData(function() {
             theme.cart.openCartDrawer();
             theme.cart.updateBadges();
             theme.cart.updateSubtotal();
             theme.cart.updateCartItems(function() {
               // Stop showing as loading
               button.classList.remove('btn--loading');
             });
             if (hasOffer) {
              theme.cart.addFreeProduct();
             }
           });
         }
       });
     },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Collection;
})();

theme.CollectionSlider = (function() {

  function CollectionSlider(container) {

    this.$slider = $(container).find('.collection-slider');

    var sliderSettings = {
     focusOnSelect: false,
     focusOnChange: false,
     accessibility: false,
     dots: false,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: true,
     mobileFirst: true,
     centerMode: false,
     responsive: [
     {
      breakpoint: 350,
      settings: {
        focusOnSelect: false,
        focusOnChange: false,
        accessibility: false,
        slidesToShow: 1,
        centerMode: true,
      }
    },
    {
      breakpoint: 600,
      settings: {
        focusOnSelect: false,
        focusOnChange: false,
        accessibility: false,
        slidesToShow: 2,
        centerMode: false,
      }
    },
    {
     breakpoint: Number(window.theme.settings.grid_medium) || 767,
     settings: {
      focusOnSelect: false,
      focusOnChange: false,
      accessibility: false,
      slidesToShow: 2,
      centerMode: false,
    }
  },
  {
   breakpoint: Number(window.theme.settings.grid_large) || 989,
   settings: {
    focusOnSelect: false,
    focusOnChange: false,
    accessibility: false,
    slidesToShow: 3,
    centerMode: false,
  }
}
]
};

this.$slider.slick(sliderSettings);
}

return CollectionSlider;
})();


  theme.Instagram = (function() {
  function Instagram(container) {

    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');
    var instafeedEl = this.instagram = $('#instafeed-' + id);
    var instafeedId = this.instagram = 'instafeed-' + id;

      var userFeed = new Instafeed({
        get: 'user',
        limit: 6,
        userId: 'self',

        target: instafeedId,
        accessToken: instafeedEl.attr('data-access-token'),


        resolution: 'standard_resolution',
        template: '<a class="grid__item medium-up--one-sixth contained" target="_blank" href="{{link}}" rel="ig" title="{{caption}}"><img class="instagram-image" orientation="square" src="{{image}}" /></a>'
    });
    if( !_.isUndefined( userFeed.options.accessToken) ){
      userFeed.run();
    }
  }
  Instagram.prototype = _.assignIn({}, Instagram.prototype, {});

  return Instagram;
})();

theme.Newsletter = (function() {

  function Newsletter(container) {
    this.$container = $(container);

    var buttonEl = document.querySelector('.newsletter__submit');
    if (buttonEl) {
      buttonEl.addEventListener('touchstart', function() {
        this.classList.add('active');
      });

      buttonEl.addEventListener('touchend', function() {
        this.classList.remove('active');
      });
    }

  }

  return Newsletter;
})();
theme.About = (function() {

  function About(container) {

    this.$slider = $(container).find('.about__slider');

    var sliderSettings = {
      dots: true,
      slidesToShow: 3,
      arrows: true,
      centerMode: false,
      focusOnSelect: false,
      focusOnChange: false,
      accessibility: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            focusOnSelect: false,
            focusOnChange: false,
            accessibility: false,
          }
        }
      ]
    };

    this.$slider.slick(sliderSettings);
  }

  return About;
})();


/*================ Modules ================*/
theme.header = {
	/*
	 * Public vars
	 */
  isFixed: false,


  /**
   * The initialising code
   */
  init: function() {

    var self = this;

    // Scroll listener
    window.registerScrollHandler.push(this.scrollHandler.bind(this));
    this.scrollHandler();

    // Menu toggle
    var btnsMenu = document.querySelectorAll('.header__btn--menu');
    btnsMenu.forEach(function(el) {
      el.addEventListener('click', self.btnMenuClickHandler);
    });

    // Menu item toggle
    var navLinks = document.querySelectorAll('.nav__item--has-child > a');
    navLinks.forEach(function(el) {
      el.addEventListener('click', self.navLinkClickHandler.bind(self));
    });

    window.addEventListener('resize', this.checkFixedHeader.bind(this));
    this.checkFixedHeader();
  },


  /**
   * Window scroll handler, adds class to body if scrolled past banner
   */
  scrollHandler: function() {

    var banner = document.querySelector('.banner');
    // var waypoint = banner.offsetHeight || 0;
    var waypoint = 0;

    // Check if we've scrolled past the banner
		if (window.pageYOffset > waypoint) {
      if (! this.isFixed) {
  			document.body.classList.add('header-fixed');
        this.isFixed = true;
      }
		}
		else {
      if (this.isFixed) {
  			document.body.classList.remove('header-fixed');
        this.isFixed = false;
      }
		}

    this.checkFixedHeader();
  },

  checkFixedHeader: function() {
    var banner = document.querySelector('.banner');
    var bannerHeight = 0;
    var sectionHeader = document.getElementById('shopify-section-header');
    var header = document.querySelector('.header');

    if (banner) {
      bannerHeight = banner.offsetHeight;

      if (document.body.classList.contains('header-fixed')) {
        if (header) {
          header.style.top = bannerHeight + 'px';
        }
      } else {
        if (header && sectionHeader) {
          header.style.top = '0px';
          sectionHeader.style.paddingTop = bannerHeight + 'px';
        }
      }
    }

  },


  /**
   * .header__btn--menu click handler
   */
  btnMenuClickHandler: function(e) {
    e.preventDefault();
    document.body.classList.toggle('menu-expanded');
  },


  /**
   * .nav__item--has-child > a click handler
   */
  navLinkClickHandler: function(e) {
    e.preventDefault();
    e.target.parentElement.classList.toggle('nav__item--expanded');
  }

};

theme.searchModal = function() {

	var banner = document.querySelector('.banner');
	var header = document.querySelector('.header');
	var btnsMenu = document.querySelector('.header__btn--menu');
	var container = document.querySelector('.search--modal');
	var inner = container.querySelector('.search__inner');
	var mobileSearchModalTogglers = document.querySelectorAll('.header__search--btn-toggle');
	var $container = $(container);

	// updateOffset();

	var form = container.querySelector('form');
	var input = container.querySelector('input[name="q"]');
	// var closeButton = form.querySelector('.search__close');
	// var results = container.querySelector('.search__results .grid');
	//
	// var cachedTerm = '';
	// var currentAjaxRequest = null;

	var searchButton = document.querySelector('.header__btn--search');

	var isShowing = false;
	searchButton.addEventListener('click', toggleModal);

	// input.addEventListener('input', inputHandler);
	form.addEventListener('submit', submitHandler);

	if(mobileSearchModalTogglers) {
		mobileSearchModalTogglers.forEach(function(toggle) {
			toggle.addEventListener('click', mobileSearchModalToggle);
		});
	}

	



	/**
	 * Adds margin to search container so it sits under the header
	 */
	function updateOffset() {

		var bannerHeight = banner ? banner.clientHeight : 0;
		var headerHeight = header.clientHeight || 0;
		var offset = bannerHeight + headerHeight;

		inner.style.marginTop = offset +'px';
	}



	/**
	 * Shows the search modal
	 */
	function toggleModal() {
		document.body.classList.remove('menu-expanded');
		if (isShowing) {
			hide();
		}
		else {
			show();
		}
	}

	
	function hideSearchForMenu() {
		if (isShowing) {
			hide();
		}
	}	
	



	/**
	 * Shows the search modal
	 */
	function show() {

		document.body.classList.add('search-modal-showing');

		// input.addEventListener('input', inputHandler);
		// closeButton.addEventListener('click', hide);
		// document.addEventListener('keydown', keydownHandler);
		input.addEventListener('focus', termFocusHandler);

		slate.a11y.trapFocus({
			$container: $container,
			namespace: 'container',
			$elementToFocus: $(input)
		});

		isShowing = true;
	}



	/**
	 * Hides the search modal
	 */
	function hide() {

		document.body.classList.remove('search-modal-showing');

		// input.removeEventListener('input', inputHandler);
		// closeButton.removeEventListener('click', hide);
		// document.removeEventListener('keydown', keydownHandler);
		input.removeEventListener('focus', termFocusHandler);

		slate.a11y.removeTrapFocus({
			$container: $container,
			namespace: 'container'
		});

		isShowing = false;
	}



	// /**
	//  * Handles the search input
	//  */
	// function inputHandler() {
	//
	// 	var term = input.value;
	//
	// 	if (term.length > 2 && term !== cachedTerm) {
	// 		querySearchTerm(term);
	// 	}
	//
	// 	cachedTerm = term;
	// }
	//
	//
	//
	// /**
	//  * Handles keydown
	//  */
	// function keydownHandler(e) {
	// 	switch (e.keyCode) {
	// 		//esc
	// 		case 27:
	// 			hide();
	// 			break;
	// 	}
	// }



	/**
	 * Handles focus on term input
	 */
	function termFocusHandler(e) {
		// Select all the text in the search box
		var input = e.target;
		input.setSelectionRange(0, input.value.length);
	}



	// /**
	//  * Ajax request for search term and prints out the results
	//  */
	// function querySearchTerm(term) {
	// 	// Encapsulate term in * wildcard to get partial matches
	// 	// Hit our json template for search term
	// 	var searchURL = '/search?type=product&q=*'+ term +'*';
	// 	// Stop any current calls
	// 	if (currentAjaxRequest != null) currentAjaxRequest.abort();
	//
	// 	currentAjaxRequest = $.getJSON(searchURL +'&view=json', function(data) {
	// 		// Reset results.
	// 		results.innerHTML = '';
	//
	// 		if (data.results_count == 0) {
	// 			results.innerHTML = "<div class='grid'><div class='grid__item text-center'><p>No results found.</p></div></div>";
	// 		}
	// 		else {
	// 			for (var i = 0, count = data.results.length; i < count; i++) {
	// 				results.innerHTML += data.results[i].markup;
	// 			}
	// 			// If there are more than 10, let's link to the search results page.
	// 			if (data.results_count > 10) {
	// 				results.innerHTML += '<p><a href="' + searchURL + '">See all results (' + data.results_count + ')</a></p>';
	// 			}
	// 		}
	// 	});
	// }



	/**
	 * Handles the search form submission
	 */
	function submitHandler(e) {
		// Wrap search term in wildcards
		e.preventDefault();

		var term = this.q.value;
		var searchURL = '/search?q=*'+ term +'*';

		window.location = searchURL;
	}

	function mobileSearchModalToggle(e) {
		e.preventDefault();
		var mobileSearchModal = document.querySelector('.header__search');
		if(mobileSearchModal) {
			mobileSearchModal.classList.toggle('active');
		}
	}

	btnsMenu.addEventListener('click', hideSearchForMenu);
};

theme.Accordion = (function() {


	/**
	 * Constructor
	 */
	function Accordion(container) {
		// Public vars
		this.container = container;
		this.showingId;
		// Reference to self for use in closures
		var self = this;

		// Add click listeners to each button
		var buttons = container.querySelectorAll('.panel__heading button');
		buttons.forEach(function(el) {
			el.addEventListener('click', self.toggleBody.bind(self));
		});

	}

	/**
	 * Event handler - decides what to show or hide
	 */
	Accordion.prototype.toggleBody = function(e) {

		var bodyId = e.target.dataset.toggle;
		var body = this.container.querySelector('#'+ bodyId);

		// Is something showing?
		if (this.showingId) {
			// Is that something showing the same as what got clicked?
			if (this.showingId === bodyId) {
				this.hideBody(body);
			}
			else {
				var showingBody = this.container.querySelector('#'+ this.showingId);
				this.hideBody(showingBody);
				this.showBody(body);
			}
		}
		else {
			this.showBody(body);
		}
	}

	/**
	 * Event handler - shows a panel body
	 */
	Accordion.prototype.showBody = function(body) {
		body.parents('.panel').classList.remove('collapsed');
		this.showingId = body.id;
	}

	/**
	 * Event handler - hides a panel body
	 */
	Accordion.prototype.hideBody = function(body) {
		body.parents('.panel').classList.add('collapsed');
		this.showingId = null;
	}

	return Accordion;
}());

theme.cart = {
	/*
	 * Public vars
	 */
	isShowing: false,
	data: {},
	currentAjaxRequest: null,
	currentTimeout: null,


	/**
	 * The initialising code
	 */
	init: function() {
		// Reference to this
		var self = this;

		// Cache some DOM elements
		this.cartCount = document.querySelector('.cart-count');
		this.cart = document.querySelector('.cart--drawer');
		this.header = this.cart.querySelector('.cart__header');
		this.btnClose = this.cart.querySelector('.cart__close');
	    this.trigger = null;
		// this.count = this.cart.querySelector('.cart__count');
		this.content = this.cart.querySelector('.cart__content');
		this.footer = this.cart.querySelector('.cart__footer');
		this.subtotal = this.cart.querySelector('.cart__subtotal');

		// Build a loader element for later use
		this.loader = document.createElement('div');
		this.loader.className = 'loader';
		// Check if we're on a cart page
		var isCartPage = document.body.classList.contains('template-cart');

		if (isCartPage) {
			this.initiateUpsellSlider();
		}
		else {
			// Initialise ajax cart
			this.updateCartItems();

			// Add listeners to buttons
			var buttonOpen = document.querySelector('.header__btn--cart');
			if (buttonOpen) {
				buttonOpen.addEventListener('click', this.toggleCartDrawer.bind(this));
			}

			this.btnClose.addEventListener('click', function(e) {
				self.closeCartDrawer();
			});

			var fade = document.querySelector('.fade');
			fade.addEventListener('click', this.closeCartDrawer.bind(this));
		}

		this.fetchData();
	},


	/**
	 * Updates the data property with data from cart.js
	 */
	fetchData: function(callback) {
		var self = this;
		$.getJSON('/cart.json', function(data) {
			self.data = data;

			if (callback) callback();
		});
	},


	/**
	 * Send data to /cart/change.js
	 */
  changeData: function(data, callback) {
    var self = this;

    $.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      complete: function(jqxhr, status) {

        self.fetchData(function() {
          self.updateBadges();
          self.updateCartItems();
          self.checkFreeProductOffer();
        });
        if (callback) callback(jqxhr, status);
      }
    });
  },


	/**
	 * Updates the header's cart badge number by the amount passed
	 */
	updateBadges: function() {
    theme.cart.cartCount.innerHTML = this.data.item_count;
    theme.cart.cartCount.style.display = 'block';
	},


	/**
	 * Get's cart html from src/templates/cart.drawer.liquid
	 */
	updateCartItems: function(callback) {
		var self = this;

		$.get('/cart/?view=drawer', function(data) {
			self.content.innerHTML = data;
			self.addItemListeners();
      self.initiateUpsellSlider();

			if (callback) callback();
			$('body').trigger('ajaxCart.afterCartLoad');

      var qtySelectors = document.querySelectorAll('.quantity__control');
      var qtyInput = document.querySelectorAll('.quantity__amount');
      var qtyLoadingElements = document.querySelectorAll('.cart-item__quantity--loading');

      if (qtyLoadingElements) {
        for(var i = 0; i < qtyLoadingElements.length; i++) {
          qtyLoadingElements[i].classList.remove('cart-item__quantity--loading-active');
        }
      }

      if (qtyInput) {
        for(var i = 0; i < qtyInput.length; i++) {
          qtyInput[i].classList.remove('quantity__amount--disabled');
        }
      }

      if (qtySelectors) {
        for(var i = 0; i < qtySelectors.length; i++) {
          qtySelectors[i].classList.remove('quantity__control--disabled');
        }
      }
		});
	},


	/**
	 * Updates the subtotal
	 */
	updateSubtotal: function() {
		this.subtotal.innerHTML = slate.Currency.formatMoney(this.data.total_price, theme.moneyFormat);
		$('body').trigger('ajaxCart.afterCartLoad');
	},


	/**
	 * Call's appropriate method depending on cart state
	 */
	toggleCartDrawer: function(e) {
    e.preventDefault();

		if (this.isShowing) {
			this.closeCartDrawer();
      this.unslickUpsellSlider();
		}
		else {
			this.openCartDrawer();
		}
	},


	/**
	 * Add class to body so we can animate the cart drawer to the open position
	 */
	openCartDrawer: function() {
		document.body.classList.add('cart-showing');
		this.isShowing = true;

    // Capture the element that opened the cart
    this.trigger = document.activeElement;
    this.btnClose.focus();
	},


	/**
	 * Removes above body class so we can animate the cart drawer to the closed position
	 */
	closeCartDrawer: function() {
		document.body.classList.remove('cart-showing');
		this.isShowing = false;

    // Throw the focus back to the element that opened the cart
    if (this.trigger) {
      this.trigger.focus();
      this.trigger = null;
    }
		// Refresh the cart incase someone changes a quantity without updating
		this.updateCartItems();
	},


	/**
	 * Add event listeners to cart items (eg. buttons, inputs)
	 */
	addItemListeners: function() {
		var self = this;
		var cartItems = document.querySelectorAll('.cart-item');

		cartItems.forEach(function(el) {
      if (el.querySelector('.quantity__control--minus')) {
        el.querySelector('.quantity__control--minus').addEventListener('click', self.minusClickHandler.bind(self));
        el.querySelector('.quantity__control--minus').addEventListener('click', function() {
          sideCardQuantityEvent(el.querySelector('.quantity__control--minus'));
        });
      }

      if (el.querySelector('.quantity__control--plus')) {
        el.querySelector('.quantity__control--plus').addEventListener('click', self.plusClickHandler.bind(self));
        el.querySelector('.quantity__control--plus').addEventListener('click', function() {
          sideCardQuantityEvent(el.querySelector('.quantity__control--plus'));
        });
      }
			
      
		});

    var upsellAddToCartBtns = document.querySelectorAll('.upsell--add-product');
    if (upsellAddToCartBtns) {
      upsellAddToCartBtns.forEach(function(upsellBtn) {
        upsellBtn.addEventListener('click', function() {
          upsellProdEvent(upsellBtn);
        });
      });
    }
	},


	/**
	 * Handles a user quantity update event - could be made DRYer with below method
	 */
	minusClickHandler: function(e) {

    e.preventDefault();

    // Clear the timeout if it is set
		if (this.currentTimeout) clearTimeout(this.currentTimeout);

		var self = this;

    var target = e.currentTarget;

    if (target.classList.contains('quantity__control--disabled')) return;

    var cartItem = target.parents('.cart-item');
		var input = cartItem.querySelector('.quantity__amount');

    // update the line item quantity
    var line = Number(target.dataset.line);
    var quantity = this.data.items[line].quantity - 1;
    if (quantity >= 0) {
      input.value = quantity;
      this.data.items[line].quantity = quantity;

      // update the badge counts
      this.data.item_count -= 1;
      this.updateBadges();

      // Update subtotal
      this.data.total_price -= this.data.items[line].price;
      this.updateSubtotal();

      if (quantity < 1) {
        cartItem.classList.add('removed');
      }
    }

  	// debounce the ajax call
		this.currentTimeout = setTimeout(function() {

      var qtySelectors = document.querySelectorAll('.quantity__control');
      var qtyInput = document.querySelectorAll('.quantity__amount');
      var qtyLoadingElements = document.querySelectorAll('.cart-item__quantity--loading');

      if (qtyLoadingElements) {
        for(var i = 0; i < qtyLoadingElements.length; i++) {
          qtyLoadingElements[i].classList.add('cart-item__quantity--loading-active');
        }
      }

      if (qtyInput) {
        for(var i = 0; i < qtyInput.length; i++) {
          qtyInput[i].classList.add('quantity__amount--disabled');
        }
      }

      if (qtySelectors) {
        for(var i = 0; i < qtySelectors.length; i++) {
          qtySelectors[i].classList.add('quantity__control--disabled');
        }
      }

      self.changeData({
        quantity: quantity,
        line: (line + 1)
      });

		}, 500);

  },


	/**
	 * Handles a user quantity update event
	 */
	plusClickHandler: function(e) {

    e.preventDefault();

    // Clear the timeout if it is set
		if (this.currentTimeout) clearTimeout(this.currentTimeout);

		var self = this;

    var target = e.currentTarget;
    // Exit if disabled
    if (target.classList.contains('quantity__control--disabled')) return;

    // TODO let user know if item is last of stock

    var cartItem = target.parents('.cart-item');
		var input = cartItem.querySelector('.quantity__amount');

    // update the line item quantity
    var line = Number(target.dataset.line);
    var quantity = this.data.items[line].quantity + 1;

    input.value = quantity;
    this.data.items[line].quantity = quantity;

    // update the badge counts
    this.data.item_count += 1;
    this.updateBadges();

    // Update subtotal
    this.data.total_price += this.data.items[line].price;
    this.updateSubtotal();
  	// debounce the ajax call
		this.currentTimeout = setTimeout(function() {

      var qtySelectors = document.querySelectorAll('.quantity__control');
      var qtyInput = document.querySelectorAll('.quantity__amount');
      var qtyLoadingElements = document.querySelectorAll('.cart-item__quantity--loading');

      if (qtyLoadingElements) {
        for(var i = 0; i < qtyLoadingElements.length; i++) {
          qtyLoadingElements[i].classList.add('cart-item__quantity--loading-active');
        }
      }

      if (qtyInput) {
        for(var i = 0; i < qtyInput.length; i++) {
          qtyInput[i].classList.add('quantity__amount--disabled');
        }
      }

      if (qtySelectors) {
        for(var i = 0; i < qtySelectors.length; i++) {
          qtySelectors[i].classList.add('quantity__control--disabled');
        }
      }

      self.changeData({
        quantity: quantity,
        line: (line + 1)
      });
		}, 500);
  },

  /**
   *  If upsell element exists
   */
  initiateUpsellSlider: function() {
    var self = this;
    $('.upsell--slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false
    });

    var btns = document.querySelectorAll('.upsell--add-product');
    if(btns) {
      $.each(btns, function(i, btn) {
        btn.addEventListener('click', function() {
          event.preventDefault();
          var variantId = this.getAttribute('data-variant');
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { id: variantId, quantity: 1 },
            dataType: "JSON",
            success: function(response) {
              self.fetchData(function() {
                self.updateBadges();
                self.updateCartItems();
                self.updateSubtotal();
                if(window.theme.template.name == 'cart') {
                  location.reload(true);
                }
              });
            }
          });
        });
      });
    }
  },

  unslickUpsellSlider: function() {
    $('.upsell--slider').slick('unslick');
  },


  addFreeProduct: function() {
    var self = this;
    var freeProduct = window.theme.settings.product_offer;
    if (window.theme.settings.enable_product_offer) {
      $.ajax({
        method: 'GET',
        url: '/products/' + freeProduct + '.json',
        dataType: 'JSON',
        success: function(product) {
          var isFreeProductInCart = false;
          self.data.items.forEach(function(item) {
            if (item.product_id === product.product.id) {
              isFreeProductInCart = true;
            }
          });

          if (!isFreeProductInCart) {
            $.ajax({
              method: 'POST',
              url: '/cart/add.js',
              data: {
                id: product.product.variants[0].id,
                quantity: 1,
                properties: {
                  "_freeOffer": "Free Product"
                }
              },
              dataType: 'JSON',
              success: function(response) {
                self.fetchData(function() {
                  self.updateBadges();
                  self.updateCartItems();
                  self.updateSubtotal();
                });
              }
            })
          }
        }
      });
    }
  },

  checkFreeProductOffer: function() {
    var self = this;
    var hasProductOffer = false;
    for (var i = 0; i < this.data.items.length; i++) {
      if (this.data.items[i].properties && this.data.items[i].properties._offer === 'Offer') {
        hasProductOffer = true;
      }
    }
    if (!hasProductOffer && this.data.items.length > 0) {
      var updatedQty = [];
      var hasFreeProd = false;
      for (var i = 0; i < this.data.items.length; i++) {
        if (this.data.items[i].properties && this.data.items[i].properties._freeOffer) {
          updatedQty.push(0);
          hasFreeProd = true;
        } else {
          updatedQty.push(this.data.items[i].quantity);
        }
      }

      if (hasFreeProd) {
        $.ajax({
          method: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updatedQty
          },
          dataType: 'JSON',
          success: function(response) {
            self.fetchData(function() {
              self.updateBadges();
              self.updateCartItems();
              self.updateSubtotal();
            });
          }
        });
      }
    }

  }
};

document.addEventListener('DOMContentLoaded', function(event) {
  var allProductCards = document.querySelectorAll('.product-card');
  if (allProductCards) {
    allProductCards.forEach(function(productCard) {
      productAddToCartEvent(productCard);
      var productLinks = productCard.querySelectorAll('a');
      if (productLinks) {
        productLinks.forEach(function(productLink) {
          productLink.addEventListener('click', function() {
            productClickEvent(productCard);
          });
        });
      }
    });
  }

  var checkoutBtn = document.querySelector('.cart__footer .btn--action');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      goToCheckoutEvent();
    });
  }

  var cartUpdatedBtn = document.querySelector('[data-cart-update-btn]');
  if (cartUpdatedBtn) {
    cartUpdatedBtn.addEventListener('click', function() {
      checkCartData();
    });
  }
});

function checkCartData() {
  var updatedProds = [];
  var allQuantities = document.querySelectorAll('.cart-quantities');
  if (allQuantities) {
    allQuantities.forEach(function(qtyEl) {
      var prevQty = parseInt(qtyEl.getAttribute('data-prev-qty'));
      var actualQty = parseInt(qtyEl.value);
      if (prevQty !== actualQty) {
        var updatedQty = 0;
        var type = 1;
        if (prevQty > actualQty) {
          updatedQty = prevQty - actualQty;
          type = 0;
        } else {
          updatedQty = actualQty - prevQty;
          type = 1;
        }
        updatedProds.push({
          'id': qtyEl.getAttribute('data-variant-id'),
          'qty': updatedQty,
          'type': type
        });
      }
    });
  }

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'JSON',
    success: function(cart) {
      cart.items.forEach(function(item) {
        var products = [];
        updatedProds.forEach(function(updatedProd) {
          if (parseInt(updatedProd.id) === item.variant_id) {
            var cartItem = {
              'name': item.product_title,
              'id': item.variant_id,
              'price': item.price / 100,
              'quantity': updatedProd.qty
            }
            products.push(cartItem);

            if (updatedProd.type === 1) {
              dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                  'currencyCode': window.theme.currency,
                  'add': {
                    'products': products
                  }
                }
              });
            } else {
              dataLayer.push({
                'event': 'removeFromCart',
                'ecommerce': {
                  'remove': {
                    'products': products
                  }
                }
              });
            }
          }
        });
      });
    }
  });
}


/**
  Function that triggers product click event and pass data to dataLayer - when user clicks on product link
  */
function productClickEvent(product) {
  var title = '';
  var url = '';
  var price = '';
  var id = '';
  var collection = product.getAttribute('data-collection');
  var position = parseInt(product.getAttribute('data-position'));

  var titleEl = product.querySelector('.product-card__title a');
  if (titleEl) {
    title = titleEl.innerHTML.trim();
    url = titleEl.href;
  }
  var priceEl = product.querySelector('[data-product-price]');
  if (priceEl) {
    price = priceEl.getAttribute('data-price');
  }
  var template = '';
  if (theme.template.name === 'collection') {
    template = 'Collection';
  }
  if (theme.template.name === 'search') {
    template = 'Search Results';
  }
  var idEl = product.querySelector('[data-product-select]');
  if (idEl) {
    id = idEl.options[idEl.selectedIndex].value;
  }

  dataLayer.push({
    'event': 'productClick',
    'ecommerce': {
      'click': {
        'actionField': {'list': collection},
        'products': [{
          'name': title,
          'id': id,
          'price': price,
          'brand': 'Carbon Coco',
          'category': collection,
          'variant': title,
          'position': position
        }]
      }
    }
  });
}

/**
  Function that triggers add to cart event and pass data to dataLayer - when user clicks on add to cart button
  */
function productAddToCartEvent(product) {
  var title = '';
  var url = '';
  var price = '';
  var id = '';
  var quantity = '';
  var collection = product.getAttribute('data-collection');
  var addToCartBtn = product.querySelector('[data-add-to-cart]');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      var titleEl = product.querySelector('.product-card__title a');
      if (titleEl) {
        title = titleEl.innerHTML.trim();
        url = titleEl.href;
      }
      var priceEl = product.querySelector('[data-product-price]');
      if (priceEl) {
        price = priceEl.getAttribute('data-price');
      }
      var idEl = product.querySelector('[data-product-select]');
      if (idEl) {
        id = idEl.options[idEl.selectedIndex].value;
      }
      var quantityEl = product.querySelector('.qty-input');
      if (quantityEl) {
        quantity = parseInt(quantityEl.value);
      }

      dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': window.theme.currency,
          'add': {
            'products': [{
              'name': title,
              'id': id,
              'price': price,
              'brand': 'Carbon Coco',
              'category': collection,
              'quantity': quantity
            }]
          }
        }
      });
    });
  }
}

/**
  Function that triggers product view event and pass data to dataLayer - when user lands on product page

  !!! I commented part of this code because page view events are in the snippet 'dataLayer-allPages'
  */
function productViewEvent(product) {
  var title = '';
  var url = '';
  var price = '';
  var id = '';
  var quantity = '';

  var titleEl = product.querySelector('.product__title h1');
  if (titleEl) {
    title = titleEl.innerHTML.trim();
  }
  var priceEl = product.querySelector('[data-product-price]');
  if (priceEl) {
    price = priceEl.getAttribute('data-price');
  }
  var idEl = product.querySelector('[data-product-select]');
  if (idEl) {
    id = idEl.options[idEl.selectedIndex].value;
  }

  // dataLayer.push({
  //   'ecommerce': {
  //     'detail': {
  //       'products': [{
  //         'name': title,
  //         'id': id,
  //         'price': price
  //       }]
  //     }
  //   }
  // });

  var addToCartBtns = product.querySelectorAll('[data-add-to-cart]');
  if (addToCartBtns) {
    addToCartBtns.forEach(function(addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        var quantityEl = product.querySelector('.qty-input');
        if (quantityEl) {
          quantity = parseInt(quantityEl.value);
        }


        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': window.theme.currency,
            'add': {
              'products': [{
                'name': title,
                'id': id,
                'price': price,
                'brand': 'Carbon Coco',
                'quantity': quantity
              }]
            }
          }
        });
      });
    });
  }

  var upsellAddToCartBtns = document.querySelectorAll('.upsell__product--add-product');
  if (upsellAddToCartBtns) {
    upsellAddToCartBtns.forEach(function(upsellBtn) {
      upsellBtn.addEventListener('click', function() {
        upsellProdEvent(this);
      });
    });
  }
}

function upsellProdEvent(product) {
  var title = product.getAttribute('data-title');
  var price = product.getAttribute('data-price');
  var id = product.getAttribute('data-variant');
  var quantity = 1;
  var type = 'addToCart';

  dataLayer.push({
    'event': 'addToCart',
    'ecommerce': {
      'add': {
        'products': [{
          'name': title,
          'id': id,
          'price': price,
          'quantity': quantity
        }]
      }
    }
  });
}

/**
  Function that triggers product add / remove event and pass data to dataLayer - when user clicks on '+' / '-' in the side cart
  */
function sideCardQuantityEvent(qtySelector) {
  var title = qtySelector.getAttribute('data-title').trim();
  var price = qtySelector.getAttribute('data-price');
  var id = qtySelector.getAttribute('data-id');
  var quantity = 0;
  var type = 'addToCart';
  if (qtySelector.getAttribute('data-type') === 'minus') {
    type = 'removeFromCart'
  }
  var qtySelector = document.querySelector('.quantity__amount-' + id);
  if (qtySelector) {
    quantity = parseInt(qtySelector.value);
  }
  var removeQty = 1;

  if (type === 'addToCart') {
    dataLayer.push({
      'event': type,
      'ecommerce': {
        'currencyCode': window.theme.currency,
        'add': {
          'products': [{
            'name': title,
            'id': id,
            'price': price,
            'quantity': quantity
          }]
        }
      }
    });
  } else {
    dataLayer.push({
      'event': type,
      'ecommerce': {
        'remove': {
          'products': [{
            'name': title,
            'id': id,
            'price': price,
            'quantity': removeQty
          }]
        }
      }
    });
  }

}

function goToCheckoutEvent() {
  var title = '';
  var url = '';
  var price = '';
  var id = '';
  var quantity = '';
  var products = [];

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'JSON',
    success: function(cart) {
      cart.items.forEach(function(item) {
        var cartItem = {
          'name': item.product_title,
          'id': item.variant_id,
          'price': item.price / 100,
          'quantity': item.quantity
        }
        products.push(cartItem);
      });

      dataLayer.push({
        'event': 'checkout',
        'ecommerce': {
          'checkout': {
            'actionField': {'step': 1},
            'products': products
          }
        }
      });
    }
  });
}

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('hero-slider', theme.HeroSlider);
  sections.register('hero-single', theme.heroSingleVideo);
  sections.register('testimonials', theme.HeroSlider);
  sections.register('featured-on', theme.FeaturedOn);
  sections.register('featured-collections', theme.FeaturedCollections);
  sections.register('featured-product', theme.FeaturedProduct);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-reviews', theme.VideoReviews);
  sections.register('collection', theme.Collection);
  sections.register('collection-slider', theme.CollectionSlider);
  sections.register('related-slider', theme.CollectionSlider);
  sections.register('instagram', theme.Instagram);
  sections.register('newsletter', theme.Newsletter);
  sections.register('about-page', theme.About);
  sections.register('banner', theme.Announcement);
  sections.register('social', theme.SocialFeed);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Run our theme scripts
  if (theme.template) {
    // Check if we have a header
    if (theme.template.hasHeader) {
      theme.header.init();
      theme.searchModal();
    }

    // Check if there is a script that matches the template name
    if (typeof theme[theme.template.name] === 'function') {
      theme[theme.template.name]();
    }

    // Check if we have a side cart
    if (theme.template.hasCart) {
      theme.cart.init();
    }
  }

  // Accordions
  document.querySelectorAll(".accordion").forEach(function(a) {
  return new theme.Accordion(a);
});

  var trigger = new ScrollTrigger({
    toggle: {
      visible: 'animate-finish',
      hidden: 'animate-start',
    },
    offset: {
      x: 0,
      y: (window.innerHeight / 4),
    },
    once: true,
  });

  $('.smooth-scroll').click(function(event) {

    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      var target = $(this.hash);
      var offsetAmount;
      if (document.querySelector('body').classList.contains('header-fixed')) {
        offsetAmount = 50;
      } else {
        offsetAmount = 150;
      }

      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - offsetAmount
        }, 500, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(':focus')) {
            return false;
          } else {
            $target.attr('tabindex', '-1');
            $target.focus();
          };
        });
      }
    }
  });

  // Detect browser for Safari 9/10 in iOS
  var BrowserDetect={init:function(){this.browser=this.searchString(this.dataBrowser)||"An unknown browser",this.version=this.searchVersion(navigator.userAgent)||this.searchVersion(navigator.appVersion)||"an unknown version",this.OS=this.searchString(this.dataOS)||"an unknown OS"},searchString:function(i){for(var n=0;n<i.length;n++){var r=i[n].string,t=i[n].prop;if(this.versionSearchString=i[n].versionSearch||i[n].identity,r){if(-1!=r.indexOf(i[n].subString))return i[n].identity}else if(t)return i[n].identity}},searchVersion:function(i){var n=i.indexOf(this.versionSearchString);if(-1!=n)return parseFloat(i.substring(n+this.versionSearchString.length+1))},dataBrowser:[{string:navigator.userAgent,subString:"Chrome",identity:"Chrome"},{string:navigator.userAgent,subString:"OmniWeb",versionSearch:"OmniWeb/",identity:"OmniWeb"},{string:navigator.vendor,subString:"Apple",identity:"Safari",versionSearch:"Version"},{prop:window.opera,identity:"Opera",versionSearch:"Version"},{string:navigator.vendor,subString:"iCab",identity:"iCab"},{string:navigator.vendor,subString:"KDE",identity:"Konqueror"},{string:navigator.userAgent,subString:"Firefox",identity:"Firefox"},{string:navigator.vendor,subString:"Camino",identity:"Camino"},{string:navigator.userAgent,subString:"Netscape",identity:"Netscape"},{string:navigator.userAgent,subString:"MSIE",identity:"Explorer",versionSearch:"MSIE"},{string:navigator.userAgent,subString:"Gecko",identity:"Mozilla",versionSearch:"rv"},{string:navigator.userAgent,subString:"Mozilla",identity:"Netscape",versionSearch:"Mozilla"}],dataOS:[{string:navigator.platform,subString:"Win",identity:"Windows"},{string:navigator.platform,subString:"Mac",identity:"Mac"},{string:navigator.userAgent,subString:"iPhone",identity:"iPhone/iPod"},{string:navigator.platform,subString:"Linux",identity:"Linux"}]};

  BrowserDetect.init();

  if (BrowserDetect.browser === 'Safari' && BrowserDetect.version < 11) {
    document.body.classList.add('old-safari');
  }

});
